module.exports = __webpack_public_path__ + "img/wro-2023-junior.924277ea.png";